import { Fragment } from 'react';
import { func, shape, string } from 'prop-types';
import { withI18next } from '../../lib/withI18next';

import MenuItem from '../shared/MenuItem';
import LanguagePicker from '../shared/LanguagePicker';

import { WHITE_COLOR } from '../../constants';

const AppMenu = ({ t, toggle, selectedLang, pathname }) => (
  <Fragment>
    <LanguagePicker
      toggle={toggle}
      selectedLang={selectedLang}
      color={WHITE_COLOR}
    />
    <MenuItem href="/" fontColor={WHITE_COLOR} pathname={pathname}>
      {t('COMPONENTS_MENU_HOME_TITLE')}
    </MenuItem>
    <MenuItem href="/about" fontColor={WHITE_COLOR} pathname={pathname}>
      {t('COMPONENTS_MENU_ABOUT_TITLE')}
    </MenuItem>
  </Fragment>
);

AppMenu.propTypes = {
  toggle: func.isRequired,
  selectedLang: shape({ value: string.isRequired, label: string.isRequired })
    .isRequired,
  pathname: string.isRequired,
};

export default withI18next()(AppMenu);



// WEBPACK FOOTER //
// components/SideMenu/AppMenu.js